import SparkMD5 from 'spark-md5';

export const getFingerprint = () => {
  try {
    return SparkMD5.hash(
      navigator.userAgent +
        (navigator.hardwareConcurrency || 'unknown') +
        (navigator.connection.type || 'unknown')
    );
  } catch (err) {
    return SparkMD5.hash('unknown');
  }
};
